import { ObjectHelpers } from "../../helpers/object-helpers";

export class CurrentPositionViewModel {
    public accountId = 0;
    public accountName = '';
    public symbol = '';
    public averageCost = 0;
    public lastPrice = 0;
    public shares = 0;
    public netSharesTradedToday = 0;
    public realizedProfitLoss = 0;
    public iChangeFromCloseDollar = 0;
    public iChangeFromClosePercent = 0;
    public temporary = false;
    
    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }

    public getKey(): string {
        return this.accountId + '_' + this.symbol;
    }

    public getOCAGroupPrefix(): string {
        return this.symbol + '-OCA';
    }

    public getTotalProfit(lastPrice: number): number {
        const sharesAverageCost = this.shares * this.averageCost;
        const currentSharesValue = this.shares * lastPrice;

        const totalProfit = currentSharesValue - sharesAverageCost;

        return totalProfit;
    }
}